import classNames from "classnames";

export default function InputGuideText({
  className = "",
  isWarning = false,
  ...props
}) {
  return (
    <p
      className={classNames(
        "min-h-[1rem] text-xs",
        isWarning ? "text-error-red" : "text-subtext-gray",
        className
      )}
    >
      {props.children}
    </p>
  );
}
